export enum TypeList  {
    Livro = 1,
    Curso = 2
}